(function () {
  const translations = window.translations?.bundle_builder?.progress_bar || {};
  const ts = translations.steps || {};

  window.maxCharms = 25;
  window.maxCharmsBFCM = 10;
  window.progressSteps = [
    {
      threshold: 5,
      discount: '10%',
      discountPercentage: 10,
      charmCount: 5,
      inProgressText: translations.add_more || 'Add {count} more Charms and get',
      completedText: translations.congrats_unlocked || '🎉 Congrats! You have unlocked',
      discountText: (ts.step_1 || '10% OFF + FREE Travel Kit ({{ price }} Value)').replace(/\{\{\s*price\s*\}\}/g, Shopify.formatMoney(window.priceConfig.travel_kit)),
      discountTextWithHolder: ts.step_1_with_holder || '10% OFF and a Travel Kit'
    },
    {
      threshold: 10,
      discount: '20%',
      discountPercentage: 20,
      charmCount: 10,
      inProgressText: translations.add_more || 'Add {count} more Charms and get',
      completedText: translations.congrats_unlocked || '🎉 Congrats! You have unlocked',
      discountText: (ts.step_2 || '20% OFF + FREE Charm Holder ({{ price }} Value)').replace(/\{\{\s*price\s*\}\}/g, Shopify.formatMoney(window.priceConfig.charm_holder))
    },
    {
      threshold: 15,
      discount: '30%',
      discountPercentage: 30,
      charmCount: 15,
      inProgressText: translations.add_more || 'Add {count} more Charms and get',
      completedText: translations.congrats_unlocked || '🎉 Congrats! You have unlocked',
      discountText: ts.step_3 || '30% OFF'
    },
    {
      threshold: 20,
      discount: '40%',
      discountPercentage: 40,
      charmCount: 20,
      inProgressText: translations.add_more || 'Add {count} more Charms and get',
      completedText: translations.congrats_unlocked || '🎉 Congrats! You have unlocked',
      discountText: ts.step_4 || '40% OFF'
    },
    {
      threshold: 25,
      discount: '50%',
      discountPercentage: 50,
      charmCount: 25,
      inProgressText: translations.add_more || 'Add {count} more Charms and get',
      completedText: translations.congrats_unlocked || '🎉 Congrats! You have unlocked',
      discountText: ts.step_5 || '50% OFF'
    }
  ]


  window.progressStepsBFCM = [
    {
      threshold: 5,
      discount: 'FREE',
      discountPercentage: 0,
      charmCount: 5,
      inProgressText: translations.add_more || 'Add {count} more Charms and get',
      completedText: translations.congrats_unlocked || '🎉 Congrats! You have unlocked',
      discountText: (ts.bfcm_step_1 || 'FREE Travel Kit ({{ price }} Value)').replace(/\{\{\s*price\s*\}\}/g, Shopify.formatMoney(window.priceConfig.travel_kit)),
      discountTextWithHolder: (ts.bfcm_step_1_with_holder || 'a Travel Kit ({{ price }} Value)').replace(/\{\{\s*price\s*\}\}/g, Shopify.formatMoney(window.priceConfig.travel_kit))
    },
    {
      threshold: 10,
      discount: 'FREE',
      discountPercentage: 0,
      charmCount: 10,
      inProgressText: translations.add_more || 'Add {count} more Charms and get',
      completedText: translations.congrats_unlocked || '🎉 Congrats! You have unlocked',
      discountText: (ts.bfcm_step_2 || 'FREE Charm Holder ({{ price }} Value)').replace(/\{\{\s*price\s*\}\}/g, Shopify.formatMoney(window.priceConfig.charm_holder))
    }
  ]
})();

// URL of resource for cached results (so we don't have to load it every time via liquid)
const charmsFlagsCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-country-flags-v2-translate-20260715.json" + "?v=" + new Date().getTime();
const charmsMapsCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-country-maps-v2-translate-20260715.json" + "?v=" + new Date().getTime();
const charmsCitiesCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-cities-translate-20260715.json" + "?v=" + new Date().getTime();
const charmsIslandsCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-islands-translate-20260715.json" + "?v=" + new Date().getTime();
const charmsStatesFlagsCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-states-flags-translate-20260715.json" + "?v=" + new Date().getTime();
const charmsStatesMapsCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-states-maps-translate-20260715.json" + "?v=" + new Date().getTime();
const charmsIslandsMapsCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-islands-maps-translate-20260715.json" + "?v=" + new Date().getTime();
const backGoldImageCharmCustom = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/gold_back.png?v=1776951467&width=900";
const backSilverImageCharmCustom = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/silver_back.png?v=1776951465&width=900";

// const personalizationPrice = ""

// Check if an item is a charm
function isCharmItem(item) {
  return item.properties && item.properties.__type === 'charm_set';
}

// Check if an item is a charm holder
function isCharmHolder(item) {
  return item.properties && item.properties.__type === 'charm_holder';
}

// Check if an item is a free gift holder
// Check both __freegift property and discount (holder already free from discount code/automatic discount)
function isFreeHolder(item) {
  // Check property __freegift
  if (item.properties && (item.properties.__freegift === 'true' || item.properties.__freegift === true)) {
    return true;
  }
  // Check discount - if there's a discount "Free Charm Holder" or total_discount > 0, then holder is already free
  if (item.discounts && item.discounts.length > 0) {
    const hasFreeHolderDiscount = item.discounts.some(discount =>
      discount.title && discount.title.toLowerCase().includes('free') &&
      discount.title.toLowerCase().includes('holder')
    );
    if (hasFreeHolderDiscount) return true;
  }
  // Check total_discount > 0 and final_price = 0 (holder is already free)
  if (item.total_discount > 0 && item.final_price === 0) {
    return true;
  }
  return false;
}

// Check if an item is a preorder charm
function isPreorderCharm(item) {
  return item.properties && (item.properties.__preorder === 'true' || item.properties.__preorder === true);
}

// Helper function to calculate isFreeHolderUnlocked based on charm count and cart data
function calculateIsFreeHolderUnlocked(charmCount, cart) {
  if (!cart || !cart.items) {
    // If no cart, just check if charmCount >= 10
    return charmCount >= 10;
  }

  let holderCount = 0;
  let freeHolderCount = 0;
  let hasPreorderCharm = false;

  // Count holders and check for preorder charms in the cart
  cart.items.forEach(item => {
    // Check if the item is a holder
    if (isCharmHolder(item)) {
      holderCount += item.quantity;
      // Count free holders
      if (isFreeHolder(item)) {
        freeHolderCount += item.quantity;
      }
    }
    // Check if there's any preorder charm
    if (isPreorderCharm(item)) {
      hasPreorderCharm = true;
    }
  });

  // Logic (ADDITIVE - các điều kiện cộng dồn):
  // 1. Có preorder charm → +1 holder free
  // 2. Có >= 10 charm sets → +1 holder free
  // 3. Buy 1 holder → get 1 holder free (logic "buy 1 get 1")
  // Example: 10 charms + 1 preorder charm + 2 holders → 2 holders free (1 from 10 charms + 1 from preorder)

  // Calculate number of holders already free from discount
  const freeHoldersFromDiscount = freeHolderCount;

  // Calculate number of holders that are NOT free (holders đã mua)
  const paidHolders = holderCount - freeHoldersFromDiscount;

  // Calculate total free holders based on conditions
  let totalFreeHolders = 0;

  // Condition 1: >= 10 charm sets → +1 holder free (chỉ 1 lần)
  if (charmCount >= 10) {
    totalFreeHolders += 1;
  }

  // Condition 2: Has preorder charm → +1 holder free (chỉ 1 lần)
  if (hasPreorderCharm) {
    totalFreeHolders += 1;
  }

  // Condition 3: "Buy 1 get 1" logic for additional holders
  // After accounting for free holders from conditions 1 & 2,
  // remaining paid holders follow "buy 1 get 1" pattern
  if (totalFreeHolders > 0 && paidHolders > totalFreeHolders) {
    const remainingPaidHolders = paidHolders - totalFreeHolders;
    const freeHoldersFromBuy1Get1 = Math.floor(remainingPaidHolders / 2);
    totalFreeHolders += freeHoldersFromBuy1Get1;
  }

  // Determine if next holder should be free
  let shouldBeFree = false;

  if (holderCount === 0 && totalFreeHolders > 0) {
    // No holders yet, but conditions met for free holder
    shouldBeFree = true;
  } else if (freeHoldersFromDiscount < totalFreeHolders) {
    // Current free holders < total free holders needed
    // Allow adding more free holders until we reach the total
    if (holderCount < totalFreeHolders) {
      shouldBeFree = true;
    }
  }

  return shouldBeFree;
}

function updateCartCharmCountFromCartData(cart) {
  if (!cart || !cart.items) {
    window.isFreeHolderUnlocked = false;
    return 0;
  }

  let charmCount = 0;

  // Count charms in the cart
  cart.items.forEach(item => {
    // Check if the item is a charm
    if (isCharmItem(item)) {
      charmCount += item.quantity;
    }
  });

  // Calculate and set isFreeHolderUnlocked based on cart data
  window.isFreeHolderUnlocked = calculateIsFreeHolderUnlocked(charmCount, cart);

  return charmCount;
}

window.discountSettings = {
  progressSteps,
  updateCartCharmCountFromCartData,
  calculateIsFreeHolderUnlocked, // Export helper function
  charmsFlagsCachedURL,
  charmsMapsCachedURL,
  charmsCitiesCachedURL,
  charmsIslandsCachedURL,
  charmsIslandsMapsCachedURL,
  charmsStatesFlagsCachedURL,
  charmsStatesCachedURL: charmsStatesFlagsCachedURL, // Legacy support
  charmsStatesMapsCachedURL,
  // personalizationPrice
  // Exposed here (not just left as bare top-level `const`) so the Preact bundle
  // (bundle-builder.jsx's updateCustomUploadImageAndSlider) can read them - that bundle is a
  // `type="module"` script with its own scope, which can't see plain `const` bindings declared
  // in this classic script, only what's actually hung off `window`. Same pattern already relied
  // on for `progressSteps` above (read as `window.discountSettings.progressSteps`).
  backGoldImageCharmCustom,
  backSilverImageCharmCustom,
}
